export const homeURL = "/";
export const commingsoonURL = "/coming-soon";
export const thankYouURL = "/thank-you";
export const notFoundURL = "/404";

